import http from '@/utils/http';

export default {
	list: data => {
		return http({url:'/api/admin/v2/supplier/list', data}).then(r => r);
	},
	listAll: () => {
		return http({url:'/api/admin/v2/supplier/listAll'}).then(r => r);
	},
	save: data => {
		return http({url:'/api/admin/v2/supplier/save', data, tip:true, loading:true}).then(r => r);
	},
	delete: data => {
		return http({url:'/api/admin/v2/supplier/delete', data, tip:true, loading:true}).then(r => r);
	},
}